var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.namespaceClass('signin')},[_c('markets-ui-loading',{attrs:{"visible":true,"size":"large"}}),_c('h2',[_vm._v("Redirecting...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }